<template>
  <div>
    <el-card class="box-card" style="margin: 40px;">
      <div slot="header" class="clearfix">
        <span>渠道管理</span>
        <el-button style="float: right;" @click="updateqx" type="success" icon="el-icon-edit" >更新</el-button>
        <el-button style="float: right; margin-right: 10px;" @click="queryuser" type="success" icon="el-icon-edit" >查看</el-button>
      </div>
      <div class="text item">
        <div class="source">
          <el-row class="querypanel">
            <el-table
              stripe
              :data="qddata"
              ref="multipleTable">
              <el-table-column
                prop="ID"
                label="ID">
              </el-table-column>
              <el-table-column
                prop="BUSS_ID"
                label="BUSSID">
              </el-table-column>
              <el-table-column
                prop="BUSS_NAME"
                label="BUSS_NAME">
              </el-table-column>
              <el-table-column
                prop="COMPANY_KEY"
                label="渠道标识">
              </el-table-column>
              <el-table-column
                prop="NAME"
                label="渠道名称">
              </el-table-column>
            </el-table>
          </el-row>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'QueryCInfo',
    data () {
      return {
        qddata: []
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.queryqd()
    },
    methods: {
      queryqd () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannels',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qddata = res.data
            } else {
              that.qddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>
  .gtopicon {
    font-size: 14px;
    padding-left: 15px;
  }
  .treerow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .treerowinput {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
    width:200px;
  }
  .treeop {
    flex: 1;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-end;
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/gg/QueryCInfo.vue